module.exports = __webpack_public_path__ + "fonts/cocon/cocon.woff";